import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { makeStyles } from '@mui/styles';

const useStyle = makeStyles(theme => ({
  button: {
    textTransform: 'none',
    fontWeight: 400,
    color: theme.palette.grey[500],
  },
  icon: {
    fill: theme.palette.grey[500],
    marginRight: 4,
  },
}));

const BackButton = ({ label, onClick }) => {
  const classes = useStyle();
  return (
    <Button size="small" onClick={onClick} className={classes.button}>
      <ArrowBackIcon className={classes.icon} />
      {label}
    </Button>
  );
};

BackButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default BackButton;
